import type { PaymentStatus } from '@pflegenavi/shared/api';

export interface ServiceProviderPayment {
  id: string;
  amount: number;
  currency: string;
  last4Iban: string | null;
  statementDescriptor: string | null;
  created: Date;
  updated: Date;
  canceled: Date | null;
  completedAt: Date | null;
  status: PaymentStatus;
  globalServiceProviderId: string;
  nursingHome: {
    id: string;
    name: string;
  };
  tenant: string;
  paymentType: string | null;
  receiptBatchId: string | null;
}

export enum ReceiptBatchPaymentState {
  PAYMENT_NOT_INITIATED = 'PAYMENT_NOT_INITIATED',
  PAYMENT_INITIATED = 'PAYMENT_INITIATED',
}

export type ReceiptBatchPaymentStatus =
  | ReceiptBatchPaymentStatusNotInitiated
  | ReceiptBatchPaymentStatusInitiated;

interface ReceiptBatchPaymentStatusInitiated {
  status: ReceiptBatchPaymentState.PAYMENT_INITIATED;
  payment: ServiceProviderPayment;
}

interface ReceiptBatchPaymentStatusNotInitiated {
  status: ReceiptBatchPaymentState.PAYMENT_NOT_INITIATED;
}

export const ServiceProviderPaymentsControllerDefinition = {
  controller: 'service-provider/payments/receipt-batches',
  endpoints: {
    getReceiptBatchPaymentStatus: {
      method: 'GET',
      url: ':receiptBatchId',
      response: undefined as unknown as ReceiptBatchPaymentStatus,
      body: undefined,
    },
  },
} as const;

export type ServiceProviderPaymentsControllerResultTypes = {
  [key in keyof (typeof ServiceProviderPaymentsControllerDefinition)['endpoints']]: (typeof ServiceProviderPaymentsControllerDefinition)['endpoints'][key]['response'];
};
export type ServiceProviderPaymentsControllerBodyTypes = {
  [key in keyof (typeof ServiceProviderPaymentsControllerDefinition)['endpoints']]: (typeof ServiceProviderPaymentsControllerDefinition)['endpoints'][key]['body'];
};
